import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdatePhotoboothOBSCell ($input: UpdatePhotoboothOBSCellInput!) {
        updatePhotoboothOBSCell (input: $input) {
            id
            send_email
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            qr_card_background_color
            qr_code_color
            button_download_text
            button_retake_text
            button_take_text
            send_text
            sent_text
            look_text
            description_text
            conditions1_text
            conditions2_text
            send_by_email_text
            print_text
            printed_text
            preparing_photo_text
            almost_there_text
            email
            qr_code
            print
            cameralabel
            mirror_image
            photo_format
            photo_timer
            photo_timer_direction
            panini_print
            loader_background_color
            loader_spinner_color
            camera_rotation
            collect_user_info
            user_info_bar_color
            user_info_text_color
            user_info_text_size
            user_info_text_position
            user_info_text_h_position
            text_font
            text_size
            letter_spacing
            change_bg_button_position
            obs_filters
            email_subject
            email_body
            email_from
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
                send_by_email_text
                print_text
                printed_text
                preparing_photo_text
                almost_there_text
                email_subject
                email_body
            }
        }
    }`,

get: gql`
    query PhotoboothOBSCell($id: ID!) {
        photoboothOBSCell(id: $id) {
            id
            send_email
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            qr_card_background_color
            qr_code_color
            button_download_text
            description_text
            conditions1_text
            conditions2_text
            send_by_email_text
            print_text
            printed_text
            preparing_photo_text
            almost_there_text
            email
            qr_code
            print
            cameralabel
            mirror_image
            photo_format
            photo_timer
            photo_timer_direction
            panini_print
            loader_background_color
            loader_spinner_color
            camera_rotation
            collect_user_info
            user_info_bar_color
            user_info_text_color
            user_info_text_size
            user_info_text_position
            user_info_text_h_position
            text_font
            text_size
            letter_spacing
            change_bg_button_position
            obs_filters
            email_subject
            email_body
            email_from
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
                send_by_email_text
                print_text
                printed_text
                preparing_photo_text
                almost_there_text
                email_subject
                email_body
            }
        }
    }`
}
